module.exports = __webpack_public_path__ + "img/user-2.30708c9d.svg";